import React from 'react';
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

export default function ApplicationsChart({ data = [] }) {
	return (
		<div style={{ width: '100%', height: 240 }}>
			<ResponsiveContainer>
				<LineChart data={data}>
					<CartesianGrid stroke="#eee" strokeDasharray="5 5" />
					<XAxis dataKey="date" />
					<YAxis />
					<Tooltip />
					<Line type="monotone" dataKey="applications" stroke="#2563eb" />
				</LineChart>
			</ResponsiveContainer>
		</div>
	);
}


